import Vue from 'vue'
import Router from 'vue-router'
import PcChat from '../views/pc-chat.vue'
import ViewMessage from '../views/view-message'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/pc-chat'
    },
    {
      path: '/pc-chat',
      component: PcChat
    },
    {
      path: '/leave-message',
      component: ViewMessage
    },
    {
      path: '/pc-satisfaction',
      component: () => import('../views/pc-satisfaction')
    }
  ]
})
